import React from 'react';
import type { MRT_TableInstance, MRT_RowData } from 'material-react-table';
import {
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon,
} from '@mui/icons-material';

export function buildSelectAllCheckboxProps<TData extends MRT_RowData>(table: MRT_TableInstance<TData>) {
  return {
    checked: table.getIsAllRowsSelected(),
    indeterminate: table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected(),
    icon: <CheckBoxOutlineBlankIcon />,
    checkedIcon: <CheckBoxIcon />,
    indeterminateIcon: <IndeterminateCheckBoxIcon />,
    sx: {
      '& .MuiSvgIcon-root': {
        color: '#00849c',
      },
      '&.MuiCheckbox-indeterminate .MuiSvgIcon-root': {
        color: '#ffffff',
      },
    },
    onChange: (_e: React.ChangeEvent<HTMLInputElement>, _checked: boolean) => {
      if (table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()) {
        table.toggleAllRowsSelected(false);
      } else {
        const next = table.getIsAllRowsSelected() ? false : true;
        table.toggleAllPageRowsSelected(next);
      }
    },
  };
}
